module.exports = __webpack_public_path__ + "media/images/result_sets/circles/5n6r8r7n-dbf17cca61a182cdea1d59519212ab62.svg";